"use client";
import { CircleCheck } from "lucide-react";
import { Container } from "@/components/container";
import {
	Alert,
	AlertContent,
	AlertDescription,
	AlertIcon,
	AlertTitle,
} from "@/components/ui/alert";
import { useAlertStore } from "@/stores/alert-store";

export default function AlertMessage() {
	const { hideAlert, variant, title, description } = useAlertStore();
	return (
		<Container>
			<Alert
				className="mt-10 mb-5"
				variant={variant}
				appearance={"light"}
				close={true}
				onClose={hideAlert}
			>
				<AlertIcon>
					<CircleCheck />
				</AlertIcon>
				<AlertContent className="w-full items-center justify-center">
					<AlertTitle className="font-semibold text-lg">{title}</AlertTitle>
					{description && <AlertDescription>{description}</AlertDescription>}
				</AlertContent>
			</Alert>
		</Container>
	);
}
